import {saveAs} from 'file-saver';
import * as docx from 'docx';
import * as docxFunc from './Docxhelper';
import {IBlocksInList} from './InterfaceControl';

interface IQuestionList {
    active: boolean;
    blocksInList: Array<IBlocksInList>;
    code: string;
    name: string;
    program: string;
    listId: number;
}

export function generateChecklistDocx(questionList: IQuestionList) {
    const generationTime = new Date(Date.now()).toLocaleString();

    function questionBlocks(blocksInList: Array<IBlocksInList>) {
        return blocksInList?.map((block, blockIndex) => [
            docxFunc.blockName(`${++blockIndex}. ${block.name}`, 26, false, true, false, true),
            ...block?.questionsInBlock?.map((question, questionIndex) => 
                docxFunc.question(`${blockIndex}.${++questionIndex}`, question.questionContent))
        ]).flat();
    }

    const doc = new docx.Document({
        sections: [{
            properties: {
            },
            headers: {
                default: new docx.Header({
                    children: [
                        docxFunc.pageHeader(`${questionList?.code} - ${questionList?.name}`),
                        docxFunc.pageHeader(`Utworzono ${generationTime}`),
                    ],
                }),
            },
            children: [
                docxFunc.header('Lista sprawdzająca'),
                docxFunc.header(`${questionList?.code} - ${questionList?.name}`),
                docxFunc.brakeLine(20),
                docxFunc.brakeLine(20),
                docxFunc.subTitle('Bloki z pytaniami:', 260, 60),
                ...questionBlocks(questionList?.blocksInList)
            ],
            footers: {
                default: new docx.Footer({
                    children: [
                        new docx.Paragraph({
                            alignment: docx.AlignmentType.CENTER,
                            children: [
                                new docx.TextRun({
                                    children: [
                                        "Strona: ",
                                        docx.PageNumber.CURRENT,
                                        " z ",
                                        docx.PageNumber.TOTAL_PAGES
                                    ],
                                    size: 16,
                                    font: 'Calibri',
                                    color: '#616161'
                                }),

                            ],
                        }),
                    ],
                }),
            },
        }],
    });

    docx.Packer.toBlob(doc).then((blob) => {
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const docblob = blob.slice(0, blob.size, mimeType);
        saveAs(docblob, `Lista sprawdzająca_${questionList?.code}.docx`)
    });
}
